export default "__VITE_ASSET__CirAAk_W__"